/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Flows_LabelInputs */

const en_map_flows_label = /** @type {(inputs: Map_Flows_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Journeys`)
};

/**
* | output |
* | --- |
* | "Journeys" |
*
* @param {Map_Flows_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const map_flows_label = /** @type {((inputs?: Map_Flows_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Flows_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_map_flows_label(inputs)
});